<template>
  <div class="loan-application-page">
    <HanderNav :is-font="true" title="融星贷·放心"></HanderNav>
    <div class="header-conatiner">
      <div style="display: flex">
        <div>
          <div class="title-1">恭喜您,您的贷款申请</div>
          <div class="title-2">初审通过</div>
          <div class="subtitle">现在申请可激活借款额度</div>
        </div>
        <div class="img-box">
          <img class="img-1" src="/images/image-1.png" />
        </div>
      </div>
    </div>
    <div class="disclaimer">
      <p>实际放款利率及放款金额以最终审批为准</p>
    </div>
    <div class="main-content">
      <div class="rx-card amount-card" :class="{ isChannel: 'has-amount-card' }">
        <div class="amount-label">
          <img src="/images/icon-amount.png" alt="额度图标" />
          <span>预估额度(元)</span>
        </div>
        <div class="amount-value">
          <div class="amount">
            <span class="currency">¥</span> <span class="amount">88,000</span>
          </div>
        </div>
        <div class="rate-info">
          <span>年化利率6.8% 起 丨 1,0000 元利息 2 元/天起</span>
          <img src="/images/icon-tip.png" alt="利率图标" />
        </div>
      </div>

      <!-- 产品详情卡片 -->
      <div class="rx-card product-details-card">
        <div class="detail-item" style="padding-top: 0">
          <span class="label">借款额度</span>
          <span class="value">5000-200000(元)</span>
        </div>
        <div class="detail-item">
          <span class="label">借款期限</span>
          <span class="value">可选 3/6/24/36 期</span>
        </div>
        <div class="detail-item">
          <span class="label">还款方式</span>
          <span class="value">随借随还，等额利息</span>
        </div>
        <div class="detail-item">
          <span class="label"> 助贷产品</span>
          <span class="value">融星贷</span>
        </div>
        <div class="detail-item" style="padding-bottom: 0">
          <span class="label">助贷机构</span>
          <span class="value">xxx 小额贷款责任有限公司</span>
        </div>
      </div>
      <AgreedProtocol v-model="isAgreement" customClass="mt-10"
        :items="['USER_REGISTRATION', 'LOAN_DISCLOSURE', 'PRIVACY_POLICY', 'PERSONAL_INFO_SHARING']" />
      <div class="apply-button-container">
        <button class="apply-button" :class="{ disabled: !isAgreement }" :disabled="!isAgreement" @click="handleApply">
          立即申请
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import HanderNav from "../components/HanderNav.vue";
import { semiMd5GetProductInfo, semiMd5UserProductConfirm } from "../api";
import AgreedProtocol from '../components/AgreedProtocol.vue';
export default {
  name: "LoanApplicationPage",
  components: {
    HanderNav,
    AgreedProtocol
  },
  data() {
    return {
      title: "融星贷·放心",
      isAgreement: true,
    };
  },
  created() {
    var channel_code = this.$route.query?.channel_code;
    var check_no = this.$route.query?. check_no;
    semiMd5GetProductInfo(channel_code, check_no).then(res => {
      console.log(res, 222)
    })
  },
  methods: {
    // 申请贷款方法
    handleApply() {
      if (!this.isAgreement) {
        return;
      }
      semiMd5UserProductConfirm().then(res => {
        console.log(res, 'submit')
      })
    },
    toggleAgree() {
      this.isAgreement = !this.isAgreement;
    },
  },
};
</script>

<style lang="less" scoped>
.rx-app-header-container {
  display: flex;
  align-items: center;
  padding-top: 10px;
  margin-bottom: 16px;

  .arrow-icon svg {
    width: 8px;
    height: 16px;
    aspect-ratio: 1/2;
  }

  .title {
    width: 100%;
    color: rgba(38, 72, 117, 0.78);
    text-align: center;
    font-family: "阿里妈妈数黑体 Bold";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
  }
}

.loan-application-page {
  position: relative;
  padding: 0 16px;
  background: linear-gradient(180deg, #b9ddf2 -1.32%, #f3fbff 75.05%);
  min-height: 100vh;

  .header-conatiner {
    text-align: left;
    padding: 0 0 0 12px;

    .title-1 {
      background: linear-gradient(91deg, #16375a 0%, #2b4b72 50%, #5f82a8 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      font-family: "AlimamaShuHeiTi";
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;
    }

    .title-2 {
      color: #ff7b00;
      font-family: "AlimamaShuHeiTi";
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;
    }

    .subtitle {
      margin-top: 10px;
      color: #4c739c;
      font-family: "Source Han Sans CN";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }

    .img-box {
      position: relative;
      margin-top: -10px;
      width: 120px;
      height: 120px;

      .img-1 {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }
    }

    .title-1.channel {
      margin-bottom: 20px;
    }

    .img-box.channel {
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .disclaimer {
    width: 343.334px;
    height: 32px;
    background: linear-gradient(91deg, #e8f7ff 0%, #cdecff 100%);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    p {
      padding-left: 12px;
      color: #2e517b;
      text-align: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }
  }

  // 主要内容区域
  .main-content {
    position: relative;
  }

  // 额度显示卡片
  .amount-card {
    position: relative;

    .amount-label {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 10px;

      img {
        width: 16px;
        height: 16px;
      }

      span {
        font-size: 14px;
        color: #698691;
        line-height: 21px;
      }
    }

    .amount-value {
      display: flex;

      .amount {
        display: flex;
        align-items: baseline;
        gap: 4px;
        flex: 1;
      }

      .currency {
        font-weight: bold;
        font-size: 24px;
        color: #254774;
        line-height: 48px;
      }

      .amount {
        font-weight: bold;
        font-size: 48px;
        color: #254774;
        line-height: 48px;
      }

      .btn-lend {
        background: #254774;
        width: 76px;
        height: 38px;
        border-radius: 19px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .amount-select {
      margin: 16px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item {
        width: 70.332px;
        height: 38px;
        flex-shrink: 0;
        border-radius: 4px;
        border: 1px solid #d9dde5;
        cursor: pointer;
        transition: all 0.3s ease;
        color: #474747;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          background: #254774;
          border: 1px solid #254774;
          color: #fff;
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }

  .has-amount-card {
    background: rgba(255, 255, 255, 0.6);
  }

  // 利率信息
  .rate-info {
    display: flex;
    align-items: center;
    gap: 6px;

    span {
      font-size: 12px;
      color: #1e7ca1;
      line-height: 21px;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  // 产品详情卡片
  .product-details-card {
    position: relative;
    margin-top: 14px;

    .detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #eff6ff;

      &:last-child {
        border-bottom: none;
      }

      .label {
        font-size: 15px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 21px;
      }

      .value {
        font-weight: 500;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.7);
        line-height: 21px;
        text-align: right;
      }
    }
  }

  .mobile-input {
    margin-top: 30px;
    margin-bottom: 10px;
    height: 50px;
    border-radius: 25px;
    border: 1px solid #b1cdff;
    background: linear-gradient(90deg,
        rgba(7, 97, 214, 0.05) 0%,
        rgba(0, 89, 255, 0.05) 100%);
    box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
  }


  // 申请按钮
  .apply-button-container {
    width: 327px;
    margin: 0 auto;
    margin-top: 10px;
    padding-bottom: 30px;

    .apply-button {
      width: 100%;
      height: 50px;
      background: linear-gradient(to right, #4d9bff, #67d1ff);
      border: 1px solid #cdedff;
      border-radius: 25px;
      box-shadow: 0px 4px 4px 0px rgba(3, 92, 242, 0.12);
      cursor: pointer;
      transition: all 0.3s ease;
      font-family: "Source_Han_Sans_CN", sans-serif;
      font-weight: bold;
      font-size: 16px;
      color: white;

      &.disabled {
        background: #cccccc;
        border: 1px solid #cccccc;
        box-shadow: none;
        cursor: not-allowed;
        color: #999999;
      }
    }
  }
}

.sms-popup {
  width: 343px;

  .title {
    color: #254774;
    text-align: center;
    font-family: "Source Han Sans CN";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    margin-bottom: 24px;
    margin-top: 14px;
  }

  .sms-input {
    width: 300px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 25px;
    border: 1px solid #b1cdff;
    background: linear-gradient(90deg,
        rgba(7, 97, 214, 0.05) 0%,
        rgba(0, 89, 255, 0.05) 100%);
    box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
  }

  .btn-sms {
    color: #254774;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-weight: 700;
    line-height: 21px;
    background: none;
    border: none;

    &:active::before {
      background: none;
    }
  }

  .btn-apply {
    margin-top: 10px;
    border-radius: 25px;
    width: 300px;
    height: 50px;
    flex-shrink: 0;
    border: 1px solid #cdedff;
    background: linear-gradient(90deg, #4d9bff 0%, #67d1ff 100%);
    box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
    color: #fff;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
  }
}

.copyright-box {
  padding-bottom: 20px;
  text-align: center;

  p {
    color: #939393;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
  }
}
</style>
